// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1TU96rJjZNghNk {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n._2YiUEC09TAIsGg {\n  margin: 4px;\n  padding: 4px;\n}\n._1gve1w34Q5KyIT {\n  margin: 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upgradeAccount": "_1TU96rJjZNghNk",
	"blurb": "_2YiUEC09TAIsGg",
	"cta": "_1gve1w34Q5KyIT"
};
export default ___CSS_LOADER_EXPORT___;
